import React from "react";
import { Skeleton } from "@mui/material";

const MusicDetailLoading = () => {
  const skeletonStyles = {
    backgroundColor: "white",
    color: "white", // Set the text color to white
  };
  return (
    <div className="mt-3">
      <div className="rounded-lg h-50">
        <Skeleton
          height={360}
          variant="rectangular"
          sx={{ ...skeletonStyles, display: "inline-block" }}
          className="rounded-lg w-full h-full"
        />
      </div>
      <div className="mt-4 block">
        <Skeleton
          variant="text"
          width={200}
          sx={{ fontSize: "1rem", ...skeletonStyles, marginTop: "10px" }}
        />
        <Skeleton
          variant="text"
          width={90}
          sx={{ fontSize: "1rem", ...skeletonStyles, marginTop: "10px" }}
        />
      </div>
    </div>
  );
};

export default MusicDetailLoading;